import type { ReactNode } from 'react'
import { Footer } from './Footer'
import { Header } from './Header'

export function SiteLayout({ children }: { children: ReactNode }) {
  return (
    <>
      <a className="skip-link" href="#main-content">Pular para o conteúdo</a>
      <canvas id="stars" aria-hidden="true" />
      <div className="scroll-progress" aria-hidden="true"><span /></div>
      <div className="cursor-glow" aria-hidden="true" />
      <Header />
      <main id="main-content">{children}</main>
      <Footer />
    </>
  )
}
